import { PlusOutlined } from "@ant-design/icons";
import { Form } from "antd";
import UploadImage from "component/upload_image";
import React, { useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const KycDocLegal = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const docLegal = Form?.useWatch("document", form) || "";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChange = (base64) => {
    form.setFieldValue("document", base64);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <>
      <Form.Item name="document" hidden initialValue={""} />
      <UploadImage
        image={docLegal}
        label="Ảnh Tài liệu Pháp lý"
        width={200}
        height={300}
        icon={<PlusOutlined style={{ color: "#aeaeae", fontSize: 30 }} />}
        onChange={handleChange}
      />
    </>
  );
};
export default KycDocLegal;
